/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const storeLocatorSideListTitleTypographySX: SxProps = {
	whiteSpace: 'normal',
};

export const nameStyle: SxProps<Theme> = ({
	fontSize: 'var(--font-size-body) !important',
	fontWeight: 'bold',
	textTransform: 'uppercase',
});

export const stylehowToGet: SxProps<Theme> = ({
	fontSize: 'var(--font-size-body)',
	cursor: 'pointer',
	color: '#0467D2',
	display: 'flex',
});

export const containerStoresList: SxProps<Theme> = () => ({});
